import * as React from 'react';
import {useSelector} from "react-redux";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";

export default function UserAccountMenu() {

    const apiServerURL = `${process.env.REACT_APP_API_URL}`;
    const loggedInUser = useSelector(x => x.auth.loggedInUser);

    return (
        <Stack
            direction="row"
            sx={{
                // p: 2,
                gap: 1,
                alignItems: 'center',
                // borderTop: '1px solid',
                // borderColor: 'divider',
            }}
        >
            <Avatar
                size="small"
                alt={``}
                src={`${apiServerURL}/resources/assets/images/customers/${loggedInUser?.customer?.id}.png`}
                sx={{ height: 26, width:'100%', backgroundColor: '#ffffff' }}
                // href={`${loggedInUser?.customer?.websiteURL}`}
                variant={'square'}
            />
        </Stack>
    );
}
